// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1h1Si","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__2zW_V","gfeWrapper":"CalendarEvent_gfeWrapper__j1Kbm"};